import { useIsModalTierFrameworkEnabled } from '@/app-shell/flags/modal-tier-framework-flag';
import {
  isModalTierFrameworkEnabledAtom,
  modalTierFrameworkDevOverrideAtom,
} from '@/atoms/modalTierFramework';
import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';

/**
 * Mirrors the PostHog kill switch into `isModalTierFrameworkEnabledAtom`, unless a
 * dev-tools override is set — then the override wins (`null` = follow the flag).
 * Renders nothing.
 */
export const ModalTierFrameworkSync = () => {
  const isEnabled = useIsModalTierFrameworkEnabled();
  const devOverride = useAtomValue(modalTierFrameworkDevOverrideAtom);
  const setEnabled = useSetAtom(isModalTierFrameworkEnabledAtom);

  useEffect(() => {
    setEnabled(devOverride ?? isEnabled);
  }, [isEnabled, devOverride, setEnabled]);

  return null;
};
